import $ from 'jquery';

const IS_DARK_THEME_LOCAL_STORAGE_KEY = 'isDarkTheme';

const handleChangeTheme = (isDarkTheme: boolean = false) => {
    $<HTMLInputElement>('#theme-controller').prop('checked', isDarkTheme);

    localStorage.setItem(IS_DARK_THEME_LOCAL_STORAGE_KEY, JSON.stringify(isDarkTheme));
}

const checkTheme = () => {
    const prefersDark = localStorage.getItem(IS_DARK_THEME_LOCAL_STORAGE_KEY);
    let isDarkTheme = prefersDark ? Boolean(JSON.parse(prefersDark)) : false;

    if (!prefersDark) {
        isDarkTheme = window.matchMedia('(prefers-color-scheme: dark)').matches;
    }

    handleChangeTheme(isDarkTheme);
}

$(function () {
    checkTheme();

    $<HTMLInputElement>("#theme-controller").on('change', function () {
        const isChecked: boolean = $(this).prop('checked');

        handleChangeTheme(isChecked);
    });

    $('#msg_box_success').fadeOut(6000);

    $<HTMLButtonElement>('#msg_box_info button[data-dismiss="alert"]').on('click', () => {
        $('#msg_box_info').fadeOut(200);
    });

    $<HTMLButtonElement>('#msg_box_warning button[data-dismiss="alert"]').on('click', () => {
        $('#msg_box_warning').fadeOut(200);
    });

    $<HTMLButtonElement>('#msg_box_error button[data-dismiss="alert"]').on('click', () => {
        $('#msg_box_error').fadeOut(200);
    });

    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', checkTheme);
});
